import { ResponseType } from 'axios';
import config from 'src/globals';
import { KeyValue } from '../library/types';

const { applicationType } = config;

const isAuthenticated = () => {
  const storage = window.localStorage;
  return storage.getItem('organisationID') && storage.getItem('userId') && storage.getItem('authToken') && storage.getItem('vendorUserId');
};

const getAuthenticationHeaders = () => {
  const storage = window.localStorage;
  return {
    'user-id': storage.getItem('userId'),
    'organisation-id': storage.getItem('organisationID'),
    'access-token': storage.getItem('authToken'),
    'vendor-user-id': storage.getItem('vendorUserId'),
    'application-type': applicationType,
  };
};

const getErrorMessage = (err: any) => {
  let errorMessage = '';
  if (!err.response) {
    errorMessage = 'Could not connect. Please check your internet connection';
  } else {
    const responseData = err.response.data;
    if (responseData && responseData.error) {
      errorMessage = responseData.error.message;
    } else {
      errorMessage = `Something went wrong\n${err.message}`;
    }
  }
  return errorMessage;
};

const getErrorMessageForBlob = async (err: any) => {
  let errorMessage = '';
  if (!err.response) {
    errorMessage = 'Could not connect. Please check your internet connection';
  } else {
    const responseData = await new Response(err.response.data).json();
    if (responseData && responseData.error) {
      errorMessage = responseData.error.message;
    } else {
      errorMessage = `Something went wrong\n${err.message}`;
    }
  }
  return errorMessage;
};

const getErrorForBlob = async (err: any) => {
  let error: any = {};
  if (!err.response) {
    error.message = 'Could not connect. Please check your internet connection';
  } else {
    const responseData = await new Response(err.response.data).json();
    if (responseData && responseData.error) {
      error = responseData.error;
    } else {
      error.message = `Something went wrong\n${err.message}`;
    }
  }
  return error;
};

const generateQueryString = (paramsArray: KeyValue[]) => {
  const queryString = paramsArray
    .map(({ key, val }) => {
      if (val || val === 0) {
        return `${key}=${encodeURIComponent(val)}`;
      }
      return null;
    })
    .filter((elem: any) => elem !== null)
    .join('&');
  return queryString;
};

const generateQueryStringFromObject = (obj: any) => {
  if (!obj) {
    return '';
  }
  const keys = Object.keys(obj);
  const x = keys.map((key) => {
    return { key, val: obj[key] };
  });
  return generateQueryString(x);
};

const generateObjectFromList = (key: string, list: any) => {
  const generatedList: any = [];
  if (list) {
    list.forEach((element: any) => {
      generatedList.push({ key, val: element });
    });
  }
  return generatedList;
};

const getFileExtension = (file: any) => {
  return file.name.split('.').pop();
};

const dataHeaders = {
  JPG: 'image/*',
  JPEG: 'image/*',
  PNG: 'image/*',
  PDF: 'application/*',
  DOCX: 'application/*',
  XLSX: 'application/*',
  CSV: 'text/csv',
  XLS: 'application/*',
  DOC: 'application/*',
};

const logoutUser = () => {
  // Remove auth storage
  const storage = window.localStorage;
  storage.removeItem('userId');
  storage.removeItem('authToken');
  storage.removeItem('vendorUserId');
  storage.removeItem('vendorName');
  storage.removeItem('vendorEmail');
  storage.removeItem('organisationID');
  storage.removeItem('logoUrl');
  storage.removeItem('permissions');
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
};

const getErrorMessageCommon = (err: any, responseType?: ResponseType) => {
  if (responseType === 'blob') {
    return getErrorMessageForBlob(err);
  }
  return getErrorMessage(err);
};

export default {
  getErrorMessageCommon,
  getAuthenticationHeaders,
  logoutUser,
  getErrorMessage,
  dataHeaders,
  getFileExtension,
  generateObjectFromList,
  generateQueryStringFromObject,
  generateQueryString,
  getErrorForBlob,
  getErrorMessageForBlob,
  isAuthenticated,
};
